import React from 'react';
import { useStyleOverride } from "../../hooks/useStyleOverride.js";
import baseStyles from "./styles.module.css.js";
export var FilterField = _ref => {
  var {
    label,
    filterComponent
  } = _ref;
  var styles = useStyleOverride('layouts/FilterField', baseStyles);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.FilterField
  }, label && /*#__PURE__*/React.createElement("label", {
    className: styles.fieldLabel
  }, label), /*#__PURE__*/React.createElement("div", {
    className: styles.filterContainer
  }, filterComponent));
};
export default FilterField;
//# sourceMappingURL=index.js.map